import { pdf, PDFViewer } from '@react-pdf/renderer'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import CetakFormPeriksaDokPPM from '../../../cetak/kapal/CetakFormPeriksaDokPPM'
import CetakSTKapal from '../../../cetak/kapal/CetakSTKapal'
import SertCPIBKapal from '../../../cetak/kapal/SertCPIBKapal'
import LHPInspeksiKapal from '../../../cetak/kapal/LHPInspeksiKapal'
import EvadanRekomTeknisKapal from '../../../cetak/kapal/EvadanRekomTeknisKapal'
import CetakAuditKecukupan from '../../../cetak/kapal/AuditKecukupan'
import CetakSptKapal from '../../../cetak/kapal/CetakSptKapal'
import { FaPaperPlane } from 'react-icons/fa'
import UploadService from '../../../../services/transaksi/UploadService'
import KapalService from '../../../../services/kapal/KapalService'
import SweetAlert from 'react-bootstrap-sweetalert'
import UserService from '../../../../services/user/UserService'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'

const ModalPreview = ({ showPreview, handleClosePreview, dataDisposisi, dataPpmKapal, reloadList }) => {

    let uploadService = useMemo(() => new UploadService(), [])
    let kapalService = useMemo(() => new KapalService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [statusTte, setStatusTte] = useState(null)
    const [rowData, setRowData] = useState(null)
    const [pegawaiData, setPegawaiData] = useState(null)
    const [uptData, setUptData] = useState(null)

    const [dataInspeksi, setDataInspeksi] = useState(null)
    const [dataSert, setDataSert] = useState(null)
    const [isUnder5GT, setIsUnder5GT] = useState(null)
    const [jenisKomoditi, setJenisKomoditi] = useState(null)
    const [jenisKomoditiEn, setJenisKomoditiEn] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal.nomorAjuKapal || (dataDisposisi.idDisposisi !== 9 && dataDisposisi.idDisposisi !== 8)) {
            return
        }

        try {
            if (dataDisposisi.idDisposisi === 9) {
                const resSpt = await kapalService.getSptByAjuAndNomor(dataPpmKapal.nomorAjuKapal, dataDisposisi.noTugas)
                if (resSpt) {
                    setStatusTte(resSpt.data.stsTte)
                    setRowData(resSpt.data)

                    const resPegawai = await pbumkuService.getPenandatanganByNip(resSpt.data?.pejabatTtd)
                    setPegawaiData(resPegawai.data)
                    const resUpt = await userService.getUptById(resSpt.data?.kdUpt)
                    setUptData(resUpt.data)
                }
            }

            if (dataDisposisi.idDisposisi === 8) {
                setIsUnder5GT(dataPpmKapal.ukuranKapal <= 5 ? 'Y' : 'T')

                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resDataInspeksi) {
                    const idInspeksi = resDataInspeksi.data.idInspeksi
                    setDataInspeksi(resDataInspeksi.data)

                    const results = await Promise.allSettled([
                        kapalService.listApprovalTeknis(idInspeksi)
                    ])

                    const [resApproval] = results

                    const dataApproval = resApproval.value?.data?.data[0]

                    const resSert = await kapalService.listKapalSertifikat(dataPpmKapal.nomorAjuKapal, dataApproval.nomorSertifikat, dataPpmKapal.namaKapal)

                    setDataSert(resSert.data.data[0])
                    setStatusTte(resSert.data.data[0].stsTte)

                    const resSertProduk = await kapalService.listKapalSertifikatProduk(resSert.data.data[0].idSert, dataPpmKapal.nomorAjuKapal)

                    const sertProduk = resSertProduk.data.data
                    const jenisKomoditiList = await Promise.all(
                        sertProduk.map(async (prod) => {
                            const res = await kapalService.getJenisKomoditiById(prod.idKomoditi)
                            return res?.data?.urJenisKomoditi
                        })
                    )
                    setJenisKomoditi(jenisKomoditiList.filter(Boolean))
                    const jenisKomoditiEnList = await Promise.all(
                        sertProduk.map(async (prod) => {
                            const res = await kapalService.getJenisKomoditiById(prod.idKomoditi)
                            return res?.data?.urJenisKomoditiEn
                        })
                    )
                    setJenisKomoditiEn(jenisKomoditiEnList.filter(Boolean))
                }
            }

        } catch (error) {
            console.log(error)
        }
    }, [dataPpmKapal, dataDisposisi, kapalService, pbumkuService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!dataPpmKapal || !dataDisposisi) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPpmKapal, dataDisposisi, fetchAllData]);


    const [loadingKirimSPT, setLoadingKirimSPT] = useState(false)
    const [showKirimSPTSuccess, setShowKirimSPTSuccess] = useState(false)
    const [showKirimSPTFailed, setShowKirimSPTFailed] = useState(false)
    const [showConfirmKirimSPT, setShowConfirmKirimSPT] = useState(false)
    const handleShowConfirmKirimSPT = () => setShowConfirmKirimSPT(true)
    const handleCloseConfirmKirimSPT = () => setShowConfirmKirimSPT(false)

    const handleClickKirimSPTSuccess = () => {
        setLoadingKirimSPT(false)
        setShowConfirmKirimSPT(false)
        setShowKirimSPTSuccess(false)
        handleClosePreview()
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickKirimSPTFailed = () => {
        setLoadingKirimSPT(false)
        setShowConfirmKirimSPT(false)
        setShowKirimSPTFailed(false)
    }

    const kirimSPTKePortal = async () => {
        setLoadingKirimSPT(true)
        try {
            let filename = 'SPT-' + dataPpmKapal.nomorAjuKapal + '.pdf'
            const toBlob = await generatePdfSPTToBlob()
            const formData = new FormData()
            formData.append('file', toBlob, filename)

            let urlFile = process.env.REACT_APP_API_URL_FILE + '/view/' + dataPpmKapal.nomorAjuKapal + '/' + filename

            const resUpload = await uploadService.uploadFileFormData(dataPpmKapal.nomorAjuKapal, formData)
            if (resUpload.status === 200) {
                let jsonPortal = {
                    filePath: urlFile,
                    idIzin: dataPpmKapal.nomorAjuKapal
                }
                console.log(jsonPortal)
                const resPortal = await uploadService.sendSptKapalToPortal(JSON.stringify(jsonPortal))
                console.log(resPortal.status)
                setShowConfirmKirimSPT(false)
                setShowKirimSPTSuccess(true)
            }
        } catch (error) {
            setShowKirimSPTFailed(true)
            console.log(error)
        }
        setLoadingKirimSPT(false)
    }

    const generatePdfSPTToBlob = async () => {
        const toblob = await pdf(<CetakSptKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} rowData={rowData} uptData={uptData} pegawaiData={pegawaiData} />).toBlob()
        return toblob
    }

    const [loadingKirimSert, setLoadingKirimSert] = useState(false)
    const [showKirimSertSuccess, setShowKirimSertSuccess] = useState(false)
    const [showKirimSertFailed, setShowKirimSertFailed] = useState(false)
    const [showConfirmKirimSert, setShowConfirmKirimSert] = useState(false)
    const handleShowConfirmKirimSert = () => setShowConfirmKirimSert(true)
    const handleCloseConfirmKirimSert = () => setShowConfirmKirimSert(false)

    const handleClickKirimSertSuccess = () => {
        setLoadingKirimSert(false)
        setShowConfirmKirimSert(false)
        setShowKirimSertSuccess(false)
        handleClosePreview()
    }

    const handleClickKirimSertFailed = () => {
        setLoadingKirimSert(false)
        setShowConfirmKirimSert(false)
        setShowKirimSertFailed(false)
    }

    const kirimSertKePortal = async () => {
        setLoadingKirimSert(true)
        try {
            let filename = 'S-' + dataSert.nomorSertifikat + '.pdf'
            const toBlob = await generatePdfSertToBlob()
            const formData = new FormData()
            formData.append('file', toBlob, filename)

            let urlFile = process.env.REACT_APP_API_URL_FILE + '/view/' + dataSert.nomorSertifikat + '/' + filename

            const resUpload = await uploadService.uploadFileFormData(dataSert.nomorSertifikat, formData)
            if (resUpload.status === 200) {
                let jsonPortal = {
                    filePath: urlFile,
                    idIzin: dataSert.nomorSertifikat
                }
                console.log(jsonPortal)
                const resPortal = await uploadService.sendSertKapalToPortal(JSON.stringify(jsonPortal))
                console.log(resPortal.status)
                setShowConfirmKirimSert(false)
                setShowKirimSertSuccess(true)
            }
        } catch (error) {
            setShowKirimSertFailed(true)
            console.log(error)
        }
        setLoadingKirimSert(false)
    }

    const generatePdfSertToBlob = async () => {
        const toblob = await pdf(<SertCPIBKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} isUnder5GT={isUnder5GT} dataInspeksi={dataInspeksi} dataSert={dataSert} jenisKomoditi={jenisKomoditi} jenisKomoditiEn={jenisKomoditiEn} />).toBlob()
        return toblob
    }

    return (
        <>
            <Modal
                show={showPreview}
                onHide={handleClosePreview}
                keyboard={false}
                size='xl'
                scrollable
                centered
            >
                <Modal.Body>
                    <PDFViewer style={{ width: 1105, height: 800 }}>
                        {
                            dataDisposisi && dataDisposisi.idDisposisi === 1 &&
                            <CetakFormPeriksaDokPPM dataPpmKapal={dataPpmKapal} dataDisposisi={dataDisposisi} />
                        }
                        {
                            dataDisposisi && dataDisposisi.idDisposisi === 2 &&
                            <CetakSTKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} />
                        }
                        {
                            dataDisposisi && dataDisposisi.idDisposisi === 9 &&
                            <CetakSptKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} rowData={rowData} uptData={uptData} pegawaiData={pegawaiData} />
                        }
                        {
                            dataDisposisi && dataDisposisi.idDisposisi === 5 &&
                            <LHPInspeksiKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} />
                        }
                        {
                            dataDisposisi && dataDisposisi.idDisposisi === 7 &&
                            <EvadanRekomTeknisKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} />
                        }
                        {
                            dataDisposisi && dataDisposisi.idDisposisi === 8 &&
                            <SertCPIBKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} isUnder5GT={isUnder5GT} dataInspeksi={dataInspeksi} dataSert={dataSert} jenisKomoditi={jenisKomoditi} jenisKomoditiEn={jenisKomoditiEn} />
                        }
                        {
                            dataDisposisi && dataDisposisi.idDisposisi === 3 &&
                            <CetakAuditKecukupan dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal} />
                        }
                    </PDFViewer>
                </Modal.Body>
                <Modal.Footer>
                    {
                        dataDisposisi && dataDisposisi.idDisposisi === 8 && statusTte === 0 &&
                        <Button size='sm' color='primary' onClick={() => handleShowConfirmKirimSert()}>{' '}<FaPaperPlane />{' '}Kirim Draft Sertifikat ke Portal</Button>
                    }
                    {
                        dataDisposisi && dataDisposisi.idDisposisi === 9 && statusTte === 0 &&
                        <Button size='sm' color='primary' onClick={() => handleShowConfirmKirimSPT()}>{' '}<FaPaperPlane />{' '}Kirim SPT ke Portal</Button>
                    }
                </Modal.Footer>
            </Modal>
            {
                showConfirmKirimSPT &&
                <SweetAlert
                    title="Kirim SPT Ke Portal Untuk TTDE?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingKirimSPT ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Kirim...
                            </>
                        ) : (
                            "Kirim"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={kirimSPTKePortal}
                    onCancel={handleCloseConfirmKirimSPT}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingKirimSPT}
                >
                    {loadingKirimSPT && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Kirim data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showKirimSPTSuccess &&
                <SweetAlert
                    success
                    title="Kirim Data Berhasil"
                    onConfirm={handleClickKirimSPTSuccess}
                    btnSize="sm"
                />
            }
            {
                showKirimSPTFailed &&
                <SweetAlert
                    danger
                    title="Kirim Data Gagal"
                    onConfirm={handleClickKirimSPTFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmKirimSert &&
                <SweetAlert
                    title="Kirim Sertifikat Ke Portal Untuk TTDE?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingKirimSert ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Kirim...
                            </>
                        ) : (
                            "Kirim"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={kirimSertKePortal}
                    onCancel={handleCloseConfirmKirimSert}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingKirimSert}
                >
                    {loadingKirimSert && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Kirim data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showKirimSertSuccess &&
                <SweetAlert
                    success
                    title="Kirim Data Berhasil"
                    onConfirm={handleClickKirimSertSuccess}
                    btnSize="sm"
                />
            }
            {
                showKirimSertFailed &&
                <SweetAlert
                    danger
                    title="Kirim Data Gagal"
                    onConfirm={handleClickKirimSertFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalPreview